import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { EncrdecrService } from '../core/services/encrdecr.service'
import { SigecService } from '@core/services/sigec.service';
import { isEmpty } from 'rxjs/operators';

@Component({
  selector: 'app-menuprincipal',
  templateUrl: './menuprincipal.component.html',
  styleUrls: ['./menuprincipal.component.css']
})
export class MenuprincipalComponent implements OnInit {
  public transaccionConvenioId: string;

  constructor(private activatedRoute: ActivatedRoute,
    public router: Router,
    private encrdecr: EncrdecrService,
    private sigecService: SigecService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params) {
        if (params.transaccionConvenioId) {
          this.transaccionConvenioId = params.transaccionConvenioId;
        } else {
          this.router.navigate([ '/alojamiento/registrarreserva' ]);
        }
      }
    });
  }

  async ngOnInit() {
    await this.proccessTransaction();
  }

  async proccessTransaction() {
    try {
      if (this.transaccionConvenioId) {
        const hash = this.encrdecr.generateHash(this.transaccionConvenioId);

        const data = await this.sigecService.validatebankpayment(this.transaccionConvenioId, hash);

        switch (data.code) {
          case '200':
            alert(data.msg);
            break;
          default:
            alert('La transaccion no es válida');
        }
      }
    } catch (error) {
      alert('Se ha generado un error' + error);
    }
  }
}
